var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"sifarnik-top-line"},[_c('div',{staticClass:"crm-top cases-top"},[_c('div',{staticClass:"cases-top-left"},[_c('navigation-office-management',{attrs:{"active_link":1}})],1)])])])
}
var staticRenderFns = []

export { render, staticRenderFns }